import { render, staticRenderFns } from "./NumberSet.vue?vue&type=template&id=51708437&scoped=true"
import script from "./NumberSet.vue?vue&type=script&lang=js"
export * from "./NumberSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51708437",
  null
  
)

export default component.exports